import React from 'react'
import { HelpModal } from '../../help/help-modal.component'

export const AttemptedCreditsHelp = ({modalRef}) =>
  <HelpModal innerRef={modalRef} title='Attempted credits'>
    Total number of credits you've registered for since you first enrolled in college. It includes credits for courses
    that were dropped/withdrawn. It is often used to calculate your Satisfactory Academic Progress. It includes current
    term credits
  </HelpModal>